/*
 * @Author: Tahiti
 * @Date: 2025-12-9
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-9
 * @Description: 灵感相关API接口
 * @FilePath: /weryai-web/api/inspiration.ts
 */
import { http } from '~/utils/request'
import type { PageResponse } from '~/api/creations'

// 灵感页面
export const getInspirationListApi = async (params: {
    page: number,
    size: number,
    relateHisId?: string,
    type?: string,
    types?: Array<string>,
    templatedId?: string,
    templateCode?: string,
    userName?: string,
    startTime?: string,
    endTime?: string,
}) => {
    return http.get<PageResponse<any>>('/api/v1/creative/inspiration/page', params)
}

// 点赞
export const changeUserLikeStateApi = (params: {
    ins_id: string,
    like: boolean
}) => {
    return http.post(`/api/v1/auth/creative/inspiration/${params.ins_id}/like?like=${params.like}`)
}

// 详情查询
export const getInspirationDetailApi = (ins_id:string) => {
    return http.get(`/api/v1/auth/creative/inspiration/${ins_id}`)
}
